import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(static)/specimen-guide/sector/[sector]/SpecimenGuideForSector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
